/**
 * トップのヘッダー
 * @constructor
 */
class HeaderTop {
  constructor() {

  }
  /**
   * トップのヘッダー
   */
  init() {
    $('.l-headerPc').addClass('l-headerPcTop');
    var pc = window.matchMedia("(min-width: 751px)").matches;

    if (pc) {
      var topHeader = $('#top');
      $(window).scroll(function () {
        if ($(this).scrollTop() > 763) {
          topHeader.addClass('is-active');
        } else {
          topHeader.removeClass('is-active');
        }
      });

    }

    $('.l-bodyInner').addClass('is-active');
  }

   
 


}

export default HeaderTop;
